import { formatDistanceToNowStrict } from "date-fns";
import { useTranslation } from "react-i18next";
import { Checkbox, Icon, Label, Popup } from "semantic-ui-react";

import "modules/AppointmentDetails/components/IndicatorsAction/IndicatorsAction.scss";
import { useAppointmentLocation } from "modules/AppointmentDetails/hooks";

import type { Appointment } from "models";

type Options = {
  key: string;
  icon: React.ReactNode;
  value: string;
  text?: string;
};

// TODO: we do this because tablet v7 cannot parse 'orange', remove when v7 is stopped
const orangeColor = "#f2711c";

type IndicatorsActionProps = {
  appointment: Appointment;
  showVat?: boolean;
  onSwitchShowVat?: () => void;
};

export const IndicatorsAction = ({ appointment, showVat = false, onSwitchShowVat }: IndicatorsActionProps) => {
  const { t } = useTranslation();

  const selectedLocation = useAppointmentLocation();

  const cartOptions: Options[] = [
    { key: "green", icon: <Icon className="shopping cart" color="green" />, value: "green", text: `${t("v8_same_day", "Same day")}` },
    { key: "blue", icon: <Icon className="shopping cart" color="blue" />, value: "blue", text: `${t("v8_to_order", "To Order")}` },
    { key: orangeColor, icon: <Icon className="shopping cart orange-cart" />, value: orangeColor, text: `${t("v8_next_day", "Next Day")}` },
    { key: "red", icon: <Icon className="shopping cart" color="red" />, value: "red", text: `${t("v8_back_order", "Back Order")}` },
    { key: "yellow", icon: <Icon className="shopping cart yellow-shop" />, value: "yellow", text: `${t("v8_arrived", "Arrived")}` }
  ];

  return (
    <div className="IndicatorsAction">
      {appointment.kiosk_label_number && (
        <Label className="IndicatorsAction-kiosk-label">
          <Icon className="tag" />
          <span>{appointment.kiosk_label_number}</span>
        </Label>
      )}

      {!appointment.dms_nr.startsWith("claire_") && (
        <div className="dms-container">
          <p>
            <strong>{t("v8_dms", "DMS")}</strong>
            {appointment.last_dms_update && formatDistanceToNowStrict(new Date(appointment.last_dms_update), { addSuffix: true })}
          </p>
        </div>
      )}

      <div className="container">
        <div className="list-container">
          <Icon className={`dollar sign ${appointment.is_money ? "limegreen" : "grey"}`} />
        </div>
      </div>

      <div className="container">
        <div className="list-container">
          <Icon className={`star ${appointment.is_star_color}`} />
        </div>
      </div>

      <div className="container">
        {appointment.is_shop_color ? (
          <Popup
            content={cartOptions.find(option => option.key === appointment.is_shop_color)?.text}
            trigger={
              <div className="list-container">
                <Icon
                  className={`shopping cart ${appointment.is_shop_color === "yellow" ? "yellow-shop" : ""} ${appointment.is_shop_color === orangeColor ? "orange-cart" : appointment.is_shop_color}`}
                />
              </div>
            }
          />
        ) : (
          <div className="list-container">
            <Icon className="shopping cart" />
          </div>
        )}
      </div>

      {selectedLocation?.dms_price_enabled && (
        <div className="container">
          <p>{t("v8_VAT", "VAT")}</p>
          <Checkbox toggle checked={showVat} onChange={onSwitchShowVat} disabled={!selectedLocation.include_vat} />
        </div>
      )}
    </div>
  );
};
